// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BkqC","right":"styles_right__266Tz"};